<template>
  <v-container>
    <v-row no-gutters>
      <v-col v-for="(f, idx) in fields" :key="'col-' + idx" v-show="!f.hidden"
        :cols="f.cols || 12" :sm="f.sm || 12" :md="f.md || 12" :style="colStyle">
        <v-select dense v-if="f.type === 'select'" :disabled="disabled || f.disabled" :label="f.label"
          v-model="f.value" :items="f.items" :prepend-inner-icon="f.icon"
          @change="$emit('data-changed', f)" :outlined="!noOutlined">
        </v-select>
        <template v-if="['text', 'mask', 'textarea'].indexOf(f.type) >= 0">
          <v-text-field dense v-if="f.type === 'text'" :disabled="disabled || f.disabled" :label="f.label"
            :rules="f.rules && f.rules.map(k => rules[k])" v-model="f.value"
            :item-value="items[idx].value"
            :prepend-inner-icon="f.icon"
            @input="$emit('data-changed', f)"
            :outlined="!noOutlined">
          </v-text-field>
          <v-text-field dense v-if="f.type === 'mask'" :disabled="disabled || f.disabled" :label="f.label"
            :rules="f.rules && f.rules.map(k => rules[k])" v-model="f.value" v-mask="f.mask"
            :prepend-inner-icon="f.icon"
            @input="$emit('data-changed', f)"
            :outlined="!noOutlined">
          </v-text-field>
          <v-textarea dense v-if="f.type === 'textarea'" :disabled="disabled || f.disabled"
            :label="f.label" v-model="f.value" :rules="f.rules && f.rules.map(k => rules[k])"
            :placeholder="f.placeholder"
            :prepend-inner-icon="f.icon"
            @input="$emit('data-changed', f)"
            :outlined="!noOutlined">
          </v-textarea>
        </template>
        <date-text-field v-if="f.type === 'date'" :disabled="disabled || f.disabled"
          :model.sync="f.value" :label="f.label" :outlined="!noOutlined">
        </date-text-field>
        <AddressTextField v-if="f.type === 'address'" :disabled="disabled || f.disabled" :label="f.label"
          v-model="f.value" :dpid="f.value" :address="f.text"
          :rules="f.rules && f.rules.map(k => rules[k])" @text-change="saveAddress(f, idx, $event)"/>
        <v-checkbox dense v-if="f.type === 'checkbox'" :disabled="disabled || f.disabled"
          :label="f.label" v-model="f.value" :rules="f.rules && f.rules.map(k => rules[k])"
          :prepend-inner-icon="f.icon"
          @change="$emit('data-changed', f)"
          :outlined="!noOutlined">
        </v-checkbox>
        <v-radio-group dense v-if="f.type === 'radio'" :disabled="disabled || f.disabled"
          v-model="f.value" :rules="f.rules && f.rules.map(k => rules[k])"
          :prepend-inner-icon="f.icon"
          @change="$emit('data-changed', f)"
          :outlined="!noOutlined" row>
          <label style="padding-right:8px">{{ f.label }}</label>
          <v-radio v-for="v in f.items" :label="v" :key="v" :value="v"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { format, parse } from 'date-fns'
import { Getter } from 'vuex-class'
import { mask } from 'vue-the-mask'
import AddressTextField from '@/components/AddressTextField'
import DateTextField from '@/components/DateTextField'

@Component({
  components: {
    AddressTextField,
    DateTextField
  },
  directives: {
    mask
  }
})
export default class EditForm extends Vue {
  @Prop(Array) items
  @Prop(Boolean) disabled
  @Prop(Boolean) createNew
  @Prop(Boolean) noOutlined
  @Prop(String) colMarginTop

  fields = []

  created () {
    this.init()
  }

  mounted () {

  }

  @Getter rules

  get colStyle () {
    if (this.colMarginTop) {
      return `margin-top:${this.colMarginTop}`
    }
    return ''
  }

  init () {
    this.fields = []
    for (let item of this.items) {
      this.fields.push(
        Object.assign(Object.create(Object.getPrototypeOf(item)), item)
      )
    }
  }

  setFieldValue (name, attr, value) {
    let item = this.fields.filter(item => item.name === name)[0]
    item[attr] = value
  }

  save () {
    let items = []
    for (let i in this.fields) {
      const f = this.fields[i]
      if (f.type === 'date') {
        try {
          f.value = format(parse(f.value, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
        } catch (e) { }
      }
      if (f.value !== this.items[i].value) {
        items.push({ name: f.name, value: f.value })
      }
    }
    return {
      id: this.items[0].value,
      items: items
    }
  }

  saveAddress (item, idx, address) {
    item.text = address
    this.$emit('data-changed')
    // this.save(item, idx)
  }

  cancel () {
    this.init()
  }
}
</script>

<style lang="scss">
i.fa, i.far { font-size: 20px !important; }
.menu-text-field.v-text-field--outlined {
  legend { width: 0 !important; }
  .v-label--active { left: -31px !important; padding: 0 4px; }
  .theme--light.v-label { background-color: #fff; }
  theme--dark.v-label { background-color: #424242; }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
